import { TableColumn } from "../../types/table-column";

export const teamColumns: TableColumn[] = [
  {
    type: "client",
    fieldName: "PERSON",
    value: "name",
    secondaryValue: "email",
    width: 18,
    hasSorting: true,
  },
  {
    type: "string",
    fieldName: "COMPANY",
    value: "company",
    width: 15,
    hasSorting: true,
  },
  {
    type: "role",
    fieldName: "ROLE",
    value: "role",
    secondaryValue: "group",
    width: 10,
    hasSorting: false,
  },
  {
    type: "date",
    fieldName: "INVITED",
    value: "createdAt",
    width: 10,
    hasSorting: true,
  },
  {
    type: "keyContact",
    fieldName: "KEY_CONTACT",
    value: "keyContact",
    width: "14%",
  },
];
